import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FolderOpen, ArrowRight, Loader2 } from 'lucide-react';
import SEO from '../components/SEO';

export default function SharedFolderPage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, found: false, folder: '', owner: '', articles: [] });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/magazine/shared-folder/${token}`)
      .then((r) => r.json())
      .then((j) => setState({ loading: false, ...j, articles: j.articles || [] }))
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, [token]);

  if (state.loading) {
    return <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center" data-testid="shared-folder-loading"><Loader2 className="w-6 h-6 animate-spin text-neutral-400" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#FAFAF8] pt-28 md:pt-32 pb-20 px-4" data-testid="shared-folder-page">
      <SEO path={`/magazine/coleccion/${token}`} title={state.found ? `Colección "${state.folder}" | Kitxens Webzine` : 'Colección | Kitxens'} noindex />
      <div className="max-w-[1180px] mx-auto">
        {!state.found ? (
          <div className="text-center py-24" data-testid="shared-folder-notfound">
            <p className="text-lg font-bold text-neutral-900">Esta colección ya no está disponible</p>
            <Link to="/magazine" className="mt-3 inline-flex items-center gap-1.5 text-[#F77F11] font-bold text-sm">Ir a la webzine <ArrowRight className="w-4 h-4" /></Link>
          </div>
        ) : (
          <>
            <p className="flex items-center gap-2 text-[#F77F11] text-[11px] tracking-[0.24em] uppercase font-bold"><FolderOpen className="w-4 h-4" /> Colección compartida</p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-neutral-900">🗂 {state.folder}</h1>
            <p className="mt-2 text-[14px] text-neutral-500">
              {state.owner ? <>Seleccionada por <b className="text-neutral-800">{state.owner}</b> en la </> : 'De la '}
              <Link to="/magazine" className="text-[#F77F11] font-bold hover:underline">Kitxens Webzine</Link> · {state.articles.length} {state.articles.length === 1 ? 'artículo' : 'artículos'}
            </p>
            <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {state.articles.map((a) => (
                <Link key={a.slug} to={`/magazine/${a.slug}?utm_source=shared_folder&utm_medium=referral_share&utm_campaign=folder_${token}`}
                  data-testid={`shared-article-${a.slug}`}
                  className="group rounded-2xl border border-neutral-200 bg-white hover:border-[#F77F11] hover:-translate-y-0.5 transition-all overflow-hidden">
                  {a.cover_image && <img src={a.cover_image} alt="" className="w-full h-40 object-cover" />}
                  <div className="p-5">
                    <p className="text-[10px] uppercase tracking-wider font-bold text-[#F77F11]">{a.category}</p>
                    <p className="mt-1.5 text-[15.5px] font-bold text-neutral-900 leading-snug group-hover:text-[#d8651a] transition-colors">{a.title}</p>
                    <p className="mt-2 text-[12.5px] text-neutral-500 line-clamp-2">{a.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
            <div className="mt-12 rounded-2xl border border-neutral-200 bg-white p-6 text-center">
              <p className="text-[14px] text-neutral-600">¿Te gustó esta colección? Crea la tuya guardando artículos con el 📌</p>
              <Link to="/magazine" data-testid="shared-folder-cta" className="mt-3 inline-flex items-center gap-2 rounded-xl bg-[#F77F11] hover:bg-[#d8651a] text-white font-bold text-[13.5px] px-5 py-2.5 transition-colors">
                Explorar la webzine <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
